<template>
  <div class="root-container">
    <div class="table-container">
    <!-- 搜索栏（固定） -->
    <div class="search-container" :class="{ 'mobile-search-top': !isDesktop }">
      <!-- 电脑端使用 Element UI 搜索框 -->
      <div v-if="isDesktop" class="desktop-search-wrapper">
        <div class="search-row">
          <el-input 
            v-model="searchKeyword" 
            placeholder="请输入名称搜索" 
            clearable
            size="small"
            class="search-input"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
          <div class="button-group">
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-plus" 
              @click="handleOpenAdd"
              class="add-button"
            >
              添加
            </el-button>
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-filter" 
              @click="toggleFilter"
              class="filter-button"
            >
              {{ isFilterOpen ? '收起筛选' : '展开筛选' }}
            </el-button>
          </div>
        </div>
        
        <!-- 电脑端筛选面板 -->
        <div v-if="isFilterOpen" class="filter-panel">
          <div class="filter-row">
            <!-- 这里可以添加更多筛选条件 -->
          </div>
          <div class="filter-actions">
            <div class="applied-filters">
              <span v-if="!appliedFilterForm.category" class="filter-tag filter-tag-empty">
                当前无筛选条件
              </span>
            </div>
            <div class="filter-buttons">
              <el-button size="small" @click="resetFilter">重置筛选</el-button>
              <el-button type="primary" size="small" @click="applyFilter">应用筛选</el-button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 手机端使用 Vant 搜索框 -->
      <div v-else class="mobile-search-wrapper">
        <van-search
          v-model="searchKeyword"
          placeholder="请输入名称搜索"
          show-action
          @search="handleSearch"
          @cancel="onSearchCancel"
          :placeholder-style="{ fontSize: '16px' }"
          :input-align="'center'"
        >
          <template #action>
            <div @click="handleSearch" style="margin-right: 10px; font-size: 16px; color: var(--primary); font-weight: 600;">搜索</div>
          </template>
        </van-search>
        
        <!-- 手机端添加按钮 -->
        <div class="mobile-add-button">
          <van-button 
            type="primary" 
            size="small" 
            block
            icon="plus"
            @click="handleOpenAdd"
            style="margin-top: 10px;"
          >
            添加
          </van-button>
        </div>
        
        <!-- 手机端筛选面板 -->
        <div v-if="isFilterOpen" class="mobile-filter-panel">
          <!-- 手机端已应用筛选条件显示 -->
          <div class="mobile-applied-filters">
            <div v-if="!appliedFilterForm.category" class="applied-tags">
              <span class="mobile-filter-tag empty">
                当前无筛选条件
              </span>
            </div>
          </div>
          
          <div class="mobile-filter-actions">
            <van-button type="default" size="small" @click="resetFilter">重置</van-button>
            <van-button type="primary" size="small" @click="applyFilter">应用</van-button>
          </div>
        </div>
        
        <!-- 手机端筛选展开按钮 -->
        <div class="mobile-filter-toggle" @click="toggleFilter">
          <van-icon :name="isFilterOpen ? 'arrow-up' : 'arrow-down'" /> 
          <span>{{ isFilterOpen ? '收起筛选' : '展开筛选' }}</span>
        </div>
      </div>
    </div>
    
    <!-- 内容区域（可滚动） -->
    <div class="content-container">
      
      <!-- 电脑端表格 -->
      <div class="table-wrapper" v-if="isDesktop">
        <el-table 
          :data="filteredData" 
          style="width: 100%" 
          tooltip-effect="dark" 
          empty-text="暂无数据"
          class="desktop-table"
          :height="tableHeight"
        >
          <el-table-column label="名称" prop="permission_name" align="left" width="160px" fixed>
          </el-table-column>
          <el-table-column label="标识" prop="permission_id" align="left" width="180px">
          </el-table-column>
          <el-table-column label="备注" prop="comment" align="left">
          </el-table-column>
          <el-table-column label="操作" align="right" fixed="right" width="155px">
            <template slot-scope="scope">
              <div class="table-actions">
                <el-link @click="handleEdit(scope.row)">
                  <i class="el-icon-edit" style="font-size:16px;"></i>编辑
                </el-link>
                <el-dropdown @command="command($event, scope.row)">
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="remove" :disabled="scope.row.permission_id === 'super'">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 手机端卡片 -->
      <div v-else class="mobile-cards">
        <div 
          v-for="item in filteredData" 
          :key="item.id" 
          class="mobile-card"
        >
          <div class="card-header">
            <h3>{{ item.permission_name }}</h3>
          </div>
          <div class="card-content">
            <p><strong>标识:</strong> {{ item.permission_id }}</p>
            <p><strong>备注:</strong> {{ item.comment || '-' }}</p>
          </div>
          <div class="card-actions">
            <van-button 
              type="primary" 
              size="small" 
              plain
              icon="edit"
              @click="handleEdit(item)"
              style="margin-right: 10px;"
            >
              编辑
            </van-button>
            <van-button 
              type="default" 
              size="small" 
              plain
              icon="ellipsis"
              @click="showMoreActions(item)"
              :disabled="item.permission_id === 'super'"
            >
              更多操作
            </van-button>
          </div>
        </div>
        
        <!-- 手机端空状态 -->
        <div v-if="filteredData.length === 0" class="mobile-empty">
          暂无数据
        </div>
        
        <!-- 手机端操作菜单，只显示一次 -->
        <van-action-sheet
          v-model="showActionSheet"
          get-container="body"
          :actions="actionSheetActions"
          @select="onActionSheetSelect"
          @close="onActionSheetClose"
        />
      </div>
    </div>
    
    <!-- 分页（固定） -->
    <div class="pagination-container">
      <el-pagination
        v-if="isDesktop"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      
      <el-pagination
        v-else
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.page"
        :page-sizes="[5, 10, 15]"
        :page-size="params.page_count"
        layout="total, prev, pager, next"
        :total="total"
        small
      ></el-pagination>
    </div>
    
    <!-- 添加/编辑抽屉 - 电脑端 -->
    <el-drawer v-if="isDesktop" title="更改权限" :visible.sync="editDrawer" :direction="direction" :before-close="handleClose" size="80%">
      <edit-comp v-if="editDrawer" @close="handleClose" @success="handleDrawerSuccess" :id="editParam.id" ref="newForm"></edit-comp>
    </el-drawer>
    
    <el-drawer v-if="isDesktop" title="添加权限" :visible.sync="addDrawer" :direction="direction" :before-close="handleClose" size="80%">
      <add-comp @close="handleClose" @success="handleDrawerSuccess" ref="newForm" v-if="addDrawer"></add-comp>
    </el-drawer>
    
  </div>
  
  <!-- 添加/编辑弹窗 - 手机端 -->
  <van-popup
    v-if="!isDesktop" 
    v-model="addPopup" 
    position="bottom" 
    :round="true"
    :close-on-click-overlay="false"
    get-container="body"
    style="max-height:80%"
    @open="handlePopupOpen"
    @close="handlePopupClose"
  >
    <div class="popup-container">
      <div class="popup-header">
        <h3>添加权限</h3>
        <van-icon name="cross" @click="handleClosePopup('add')" class="close-icon" />
      </div>
      <div class="popup-content">
        <add-comp @close="handleClosePopup('add')" @success="handlePopupSuccess" ref="newForm"></add-comp>
      </div>
    </div>
  </van-popup>
  
  <van-popup
    v-if="!isDesktop" 
    v-model="editPopup" 
    position="bottom" 
    :round="true"
    :close-on-click-overlay="false"
    get-container="body"
    style="max-height:80%"
    @open="handlePopupOpen"
    @close="handlePopupClose"
  >
    <div class="popup-container">
      <div class="popup-header">
        <h3>更改权限</h3>
        <van-icon name="cross" @click="handleClosePopup('edit')" class="close-icon" />
      </div>
      <div class="popup-content">
        <edit-comp @close="handleClosePopup('edit')" @success="handlePopupSuccess" :id="editParam.id" ref="newForm"></edit-comp>
      </div>
    </div>
  </van-popup>
</div>
</template>

<script>
// 静态导入 Vant 弹框组件
import { Dialog, Toast, Icon } from 'vant'
import { searchPermissions, deletePermission } from '@/api/system'
import addComp from "./components/add.vue";
import editComp from "./components/edit.vue";

export default {
  name: "newindex",
  components: { addComp, editComp, [Icon.name]: Icon },
  data() {
    return {
      // 搜索相关
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      isDesktop: true,
      // 筛选相关
      isFilterOpen: false,
      filterForm: {
        category: ''
      },
      // 保存已应用的筛选条件
      appliedFilterForm: {
        category: ''
      },
      // 手机端操作菜单
      showActionSheet: false,
      currentRow: null,
      actionSheetActions: [
        { name: '删除', type: 'danger' }
      ],
      
      params: {
        page:1,
        page_count: 10
      },
      // 查询数据
      tableData: [],
      total: 0,
      
      // 添加组件传参
      addDrawer: false,
      addPopup: false,
      
      // 更新组件传参
      editDrawer: false,
      editPopup: false,
      editParam: {
        id:0
      },
      
      direction: "rtl",
      height: 0
    };
  },
  computed: {
    filteredData() {
      return this.tableData.filter(item => {
        // 关键词搜索
        const keyword = this.searchKeyword.toLowerCase()
        const matchesKeyword = !keyword || 
                             item.permission_name.toLowerCase().includes(keyword) ||
                             item.permission_id.toLowerCase().includes(keyword) ||
                             (item.comment && item.comment.toLowerCase().includes(keyword)) ||
                             item.id.toString().includes(keyword)
        
        return matchesKeyword
      })
    },
    tableHeight() {
      if (!this.isDesktop) return 'auto'
      // 计算表格高度：减去顶部栏、筛选区域、分页栏和底部的高度
      const headerHeight = 60 // 顶部栏高度
      const searchHeight = this.isFilterOpen ? 180 : 60 // 搜索栏高度（包含筛选面板）
      const paginationHeight = 60 // 分页栏高度
      const footerHeight = 40 // 底部高度
      const padding = 20 // 页面内边距
      return window.innerHeight - headerHeight - searchHeight - paginationHeight - footerHeight - padding - 100 // 100是其他元素的额外高度
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.handleResize)
    // 初始化时，将当前筛选条件设为已应用条件
    this.appliedFilterForm = JSON.parse(JSON.stringify(this.filterForm))
    this.getTableData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.checkScreenSize()
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    handleSearch() {
      this.params.page = 1
      this.getTableData()
    },
    // 处理添加按钮点击
    handleOpenAdd() {
      if (this.isDesktop) {
        this.addDrawer = true
      } else {
        this.addPopup = true
      }
    },
    // 切换筛选面板
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen
    },
    // 应用筛选
    applyFilter() {
      // 保存当前筛选条件为已应用条件
      this.appliedFilterForm = JSON.parse(JSON.stringify(this.filterForm))
      this.params.page = 1
      this.getTableData()
    },
    // 重置筛选
    resetFilter() {
      // 初始化筛选条件
      const initialFilter = {
        category: ''
      }
      // 同时重置当前筛选表单和已应用筛选条件
      this.filterForm = JSON.parse(JSON.stringify(initialFilter))
      this.appliedFilterForm = JSON.parse(JSON.stringify(initialFilter))
      this.params.page = 1
      this.getTableData()
    },
    // 处理编辑
    handleEdit(row) {
      this.editParam = {
        id: row.id
      }
      if (this.isDesktop) {
        this.editDrawer = true
      } else {
        this.editPopup = true
      }
    },
    // 处理命令
    command(cmd, row) {
      if (cmd === 'remove') {
        this.handleDelete(row.id)
      }
    },
    // 显示手机端更多操作菜单
    showMoreActions(row) {
      this.currentRow = row
      this.showActionSheet = true
    },
    // 处理手机端操作菜单选择
    onActionSheetSelect(action, index) {
      if (action.name === '删除') {
        this.handleDelete(this.currentRow.id)
      }
      this.showActionSheet = false
    },
    // 关闭手机端操作菜单
    onActionSheetClose() {
      this.currentRow = null
    },
    // 获取表格数据
    getTableData() {
      searchPermissions(this.params).then(res=>{
        if (res.code === 200){
          this.tableData = res.data.data
          this.params.page = res.data.current_page
          this.params.page_count = res.data.per_page
          this.total = res.data.total
        }
      })
    },
    // 删除权限
    handleDelete(id) {
      if (this.isDesktop) {
        this.$confirm('删除后无法恢复，请慎重考虑，确认删除数据吗？')
          .then(_ => {
            deletePermission(id).then(res=>{
                this.getTableData()
                this.$notify({
                  title: '成功',
                  message: '删除成功',
                  type: 'success'
                });
              })
          })
          .catch(_ => {});
      } else {
        Dialog.confirm({
          title: '提示',
          message: '删除后无法恢复，请慎重考虑，确认删除数据吗？',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        .then(() => {
          deletePermission(id).then(res=>{
            this.getTableData()
            Toast({
              message: '删除成功',
              type: 'success',
              duration: 2000
            })
          })
        })
        .catch(() => {
          // 取消删除
        })
      }
    },
    handleSizeChange(val) {
      this.params.page_count = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getTableData()
    },
    // 处理 Vant 搜索框取消事件
    onSearchCancel() {
      this.searchKeyword = ''
      this.getTableData()
    },
    // 关闭添加/修改 - 电脑端
    handleClose() {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.addDrawer = false;
          this.editDrawer = false;
        })
        .catch((_) => { });
    },
    // 关闭弹窗 - 手机端
    handleClosePopup(type) {
      Dialog.confirm({
        title: '提示',
        message: '确认关闭？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      .then(() => {
        if (type === 'add') {
          this.addPopup = false;
        } else if (type === 'edit') {
          this.editPopup = false;
        }
      })
      .catch(() => {
        // 取消关闭
      })
    },
    
    // 弹窗打开时禁止页面滚动
    handlePopupOpen() {
      document.body.style.overflow = 'hidden';
    },
    
    // 弹窗关闭时恢复页面滚动
    handlePopupClose() {
      document.body.style.overflow = '';
    },
    // 添加/修改成功 - 电脑端
    handleDrawerSuccess() {
      this.addDrawer = false;
      this.editDrawer = false;
      this.getTableData();
      if (this.$refs.newForm && this.$refs.newForm.$refs.form) {
        this.$refs.newForm.$refs.form.resetFields();
      }
    },
    // 添加/修改成功 - 手机端
    handlePopupSuccess() {
      this.addPopup = false;
      this.editPopup = false;
      this.getTableData();
      if (this.$refs.newForm && this.$refs.newForm.$refs.form) {
        this.$refs.newForm.$refs.form.resetFields();
      }
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.handleResize)
    this.getTableData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
/* 使用全局样式中定义的 CSS 变量 */
.table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 搜索栏（固定） */
.search-container {
  margin-bottom: 0;
  padding: 20px;
  background-color: var(--background);
  border-radius: var(--border-radius);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

/* 手机端搜索置顶 */
.mobile-search-top {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  padding: 10px 15px;
}

.search-container h2 {
  margin-bottom: 20px;
  color: var(--text);
}

/* 电脑端搜索容器 */
.desktop-search-wrapper {
  width: 100%;
}

.search-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 100%;
  max-width: 400px;
  font-size: var(--font-size-sm);
}

.filter-button {
  white-space: nowrap;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  align-items: center;
}

.add-button {
  white-space: nowrap;
}

/* 手机端添加按钮样式 */
.mobile-add-button {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

/* 筛选面板 */
.filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 15px;
  margin-top: 10px;
  box-shadow: var(--shadow);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 筛选操作区域 */
.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--border);
}

/* 已应用筛选标签容器 */
.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

/* 单个筛选标签样式 */
.filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  display: inline-flex;
  align-items: center;
}

/* 空状态筛选标签 */
.filter-tag-empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 筛选按钮容器 */
.filter-buttons {
  display: flex;
  gap: 10px;
}

.filter-item label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
}

/* 手机端已应用筛选条件样式 */
.mobile-applied-filters {
  padding: 10px 15px;
  background-color: var(--bg-100);
  border-radius: var(--border-radius);
  margin-bottom: 15px;
}

.mobile-applied-filters .applied-title {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text);
  margin-bottom: 8px;
}

.mobile-applied-filters .applied-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mobile-filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  display: inline-block;
}

.mobile-filter-tag.empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 手机端筛选操作按钮区域 */
.mobile-filter-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  margin-top: 10px;
  border-top: 1px solid var(--border);
}

/* 手机端搜索容器 */
.mobile-search-wrapper {
  width: 100%;
}

.mobile-search-container {
  margin-bottom: 15px;
}

/* 手机端筛选面板 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 手机端筛选展开按钮 */
.mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  margin-top: 10px;
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  color: var(--text-200);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-filter-toggle:hover {
  background-color: var(--border-light);
}

/* 内容区域（可滚动） */
.content-container {
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding: 20px 0;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
}

/* 电脑端表格 */
.table-wrapper {
  height: 100%;
  margin-bottom: 0;
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--shadow);
  font-size: 14px;
}

.table-actions{
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  gap: 10px;
  font-size: 14px;
}

.desktop-table {
  height: 100%;
  margin-bottom: 0;
  font-size: 14px;
}

/* 手机端卡片 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
}

.mobile-card {
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: 15px;
  background-color: var(--bg-200);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
}

.mobile-card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-light);
}

.card-title {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.card-title h3 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-content {
  border-bottom: 1px solid var(--border-light);
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.card-content p {
  margin: 8px 0;
  font-size: var(--font-size-sm);
  color: var(--text-200);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  line-height: 1.6;
  flex-wrap: wrap;
}

.card-content p strong {
  color: var(--text);
  font-weight: 500;
  min-width: 80px;
  text-align: left;
  flex-shrink: 0;
}

.card-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  flex-wrap: wrap;
  align-items: center;
}

/* Vant按钮样式优化 */
.card-actions .van-button {
  font-size: 13px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

/* Vant下拉菜单样式优化 */
.card-actions .van-dropdown-menu {
  font-size: 13px;
  flex-shrink: 0;
}

/* 手机端空状态 */
.mobile-empty {
  text-align: center;
  padding: 40px 0;
  color: var(--text-200);
  font-size: var(--font-size-sm);
}

/* 适配小屏幕，确保操作按钮不会换行 */
@media (max-width: 375px) {
  .card-actions {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }
  
  .card-actions .van-button {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 8px;
  }
  
  .card-actions .van-dropdown-menu {
    width: 100%;
  }
}

/* 手机端弹窗样式 */
.popup-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--background);
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: var(--background);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 10;
}

.popup-header h3 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text);
}

.popup-header .close-icon {
  font-size: 20px;
  color: var(--text-200);
  cursor: pointer;
  transition: color 0.2s ease;
}

.popup-header .close-icon:hover {
  color: var(--text);
}

.popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: var(--background);
}

/* 筛选面板样式 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.mobile-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px;
  background-color: var(--background);
}

/* 分页（固定） */
.pagination-container {
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
  border-top: 1px solid var(--border);
  text-align: right;
  box-sizing: border-box;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .search-container h2 {
    margin-bottom: 15px;
  }
  
  .search-container .search-input {
    display: none;
  }
  
  .content-container {
    padding: 10px 0;
  }
  
  .search-input {
    max-width: 100%;
  }
  
  .pagination-container {
    text-align: center;
    padding: 15px;
  }
  
  .filter-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .filter-item {
    width: 100%;
  }
  
  .filter-item .el-select,
  .filter-item .el-input-number {
    width: 100% !important;
  }
}

@media (min-width: 769px) {
  .search-container .mobile-search-container,
  .mobile-filter-toggle {
    display: none;
  }
  
  .desktop-table {
    display: block;
  }
  
  .mobile-cards {
    display: none;
  }
}

@media (max-width: 768px) {
  .search-container{
    width: 100vw;
    margin-left: -15px;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    background-color: var(--bg-200);
  }
  .van-search{
    padding:0;
  }
  .desktop-table {
    display: none;
  }
  
  .mobile-cards {
    display: flex;
  }
  
  .search-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .search-input {
    max-width: 100%;
  }
}
</style>